import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, SaveButton, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMonitorRecoveryControl extends Layout {
    checkboxAutoInLastAlive: Checkbox;
    checkboxAutooutLastAlive: Checkbox;
    checkboxBackups: Checkbox;
    checkboxCheckArrivalUpdt: Checkbox;
    checkboxCheckDeptUpdate: Checkbox;
    checkboxChkInboundRec: Checkbox;
    checkboxChkOutboundRec: Checkbox;
    checkboxComminLastAlive: Checkbox;
    checkboxCommoutLastAlive: Checkbox;
    checkboxLogoutLastAlive: Checkbox;
    checkboxRecFirstInbound: Checkbox;
    checkboxRecFirstOutbound: Checkbox;
    checkboxRecInRunnable: Checkbox;
    checkboxRecOutRunnable: Checkbox;
    checkboxRefreshApiUserDt: Checkbox;
    checkboxRunRecInDir: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyFunctionalAcknowledgementsProcessed: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyFunctionalAcknowledgementsReceived: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyInvoices: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyLoadTenders: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyRemittanceAdvices: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyReplies: Checkbox;
    checkboxTransactionSetsInboundActivityVerifyStatuses: Checkbox;
    checkboxTransactionSetsOutboundActivitySuccessfullyTransmitted: Checkbox;
    checkboxTransactionSetsOutboundActivityTransferredFromBilling: Checkbox;
    checkboxTransactionSetsOutboundActivityVerifyFunctionalAcknowledgementsReceived: Checkbox;
    checkboxTransactionSetsOutboundActivityVerifyLoadTenders: Checkbox;
    checkboxTransactionSetsOutboundActivityVerifyReplies: Checkbox;
    checkboxTransactionSetsOutboundActivityVerifyStatuses: Checkbox;
    horizontalspacer10: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    labelAdditionalDirectories: Label;
    labelI: Label;
    labelIntervalinminutes: Label;
    labelLastAlive: Label;
    labelLastTimeRun: Label;
    labelRecoveryInboundAgeToReport: Label;
    labelRecoveryInboundIntervalInMinutes: Label;
    labelRecoveryOutboundAgeToReport: Label;
    labelRecoveryOutboundIntervalInMinutes: Label;
    labelTransactionSetsInboundActivity1: Label;
    labelTransactionSetsInboundActivity2: Label;
    labelTransactionSetsInboundActivity3: Label;
    labelTransactionSetsOutboundActivity1: Label;
    labelTransactionSetsOutboundActivity2: Label;
    labelTransactionSetsOutboundActivity3: Label;
    labelTransactionSetsOutboundActivityVerifyBills: Label;
    layoutMonitorRecovery: LayoutHeader;
    panelArriveDepartIntervals: Panel;
    panelCheckUpdates: Panel;
    panelEdiMonitorZbfrloc: Panel;
    panelProcesses: Panel;
    panelRecoveryInboundCheckboxes: Panel;
    panelRecoveryInboundTextboxes: Panel;
    panelRecoveryOutboundCheckboxes: Panel;
    panelRecoveryOutboundTextboxes: Panel;
    panelTransactionSetsInboundActivityAuditData: Panel;
    panelTransactionSetsInboundActivityLeft: Panel;
    panelTransactionSetsInboundActivityRight: Panel;
    panelTransactionSetsOutboundActivityAuditData: Panel;
    panelTransactionSetsOutboundActivityLeft: Panel;
    panelTransactionSetsVerifyBills: Panel;
    savebuttonMonitorRecoveryControl: SaveButton;
    sourceEdiMonitor: DataSource;
    sourceEdimonitorControl: DataSource;
    sourceEdimonitorZbfrloc: DataSource;
    tabLogistics: Tab;
    tabProcesses: Tab;
    tabProfileBackups: Tab;
    tabRecovery: Tab;
    tabRecoveryInbound: Tab;
    tabRecoveryOutbound: Tab;
    tabTab1: Tab;
    tabTransactionSetInboundActivity: Tab;
    tabTransactionSets: Tab;
    tabTransactionSetsOutboundActivity: Tab;
    tabZeroByte: Tab;
    tableDirectoryLocation: Table;
    tabsetMonitorRecoveryControl: Tabset;
    tabsetRecovery: Tabset;
    tabsetTransactionSets: Tabset;
    textBoxZeroByte: Textbox;
    textboxAutoinPingInt: Textbox;
    textboxAutooutPingInt: Textbox;
    textboxCheckArrivalInt: Textbox;
    textboxCheckDeptInt: Textbox;
    textboxCommoutPingInt: Textbox;
    textboxDayOfMonth: Textbox;
    textboxDayOfWeek: Textbox;
    textboxInboundRecInt: Textbox;
    textboxLogoutPingInt: Textbox;
    textboxOccurrence: Textbox;
    textboxOutboundRecInt: Textbox;
    textboxProfileBackupTod: Textbox;
    textboxRecInDir: Textbox;
    textboxRecInRunInt: Textbox;
    textboxRecOutRunInt: Textbox;
    textboxTimeOfDay: Textbox;
    textboxTransactionSetsInboundActivityHours: Textbox;
    textboxTransactionSetsInboundActivityMinutes: Textbox;
    textboxTransactionSetsOutboundActivityHours: Textbox;
    textboxTransactionSetsOutboundActivityMinutes: Textbox;
    textboxZerobyteDeleteage: Textbox;
}
